export const PHOTO_TRANSFER_WAITING = 'Des photos sont encore sur cet appareil. Le transfert attend qu\'elles soient envoyées.';

/** Une photo en attente ne suit que son rapport. Hors ligne, le transfert s'arrête. */
export function transferPhotoDecision({ online, pendingCount }) {
  if (pendingCount > 0 && !online) {
    return { ok: false, message: PHOTO_TRANSFER_WAITING };
  }
  return { ok: true, message: '' };
}

export function photosForReport(rows, reportId) {
  if (!reportId) return [];
  return (rows || []).filter((row) => row.reportId === reportId);
}

/** Un 404 veut dire que le rapport n'existe pas encore : la photo reste en file. */
export function photoErrorBlocksDraft(status) {
  return status !== 404;
}

/** Le brouillon en cours est unique par agent. Modifier un rapport déjà envoyé ne l'écrase pas. */
export function submitKeepsLocalDraft(editMode) {
  return Boolean(editMode);
}

/** Pendant la synchro du brouillon, une photo dont le rapport n'existe pas encore reste en file. */
export async function uploadTaggedKeepingMissing(photos, send) {
  const kept = [];
  for (const photo of photos || []) {
    if (!photo?.reportId) continue;
    try {
      await send(photo);
    } catch (error) {
      if (!photoErrorBlocksDraft(error?.response?.status)) {
        kept.push(photo);
        continue;
      }
      throw error;
    }
  }
  return kept;
}

/** File locale des photos de ronde, à côté du brouillon.

Le stockage est injecté : IndexedDB dans l'application, mémoire dans les tests.
`clearAll` est le geste de purge quand la session agent est refusée.
Chaque photo est liée à un rapport précis dès l'ajout.
*/
export function createPhotoQueue(store) {
  return {
    async add(agentId, blob, extra = {}) {
      if (!agentId) throw new Error('Agent manquant');
      const reportId = String(extra.reportId || '').trim();
      if (!reportId) throw new Error('Photo sans rapport');
      const record = {
        id: extra.id || (globalThis.crypto?.randomUUID ? globalThis.crypto.randomUUID() : `photo-${Date.now()}`),
        agentId,
        blob,
        contentType: blob?.type || extra.contentType || 'image/jpeg',
        createdAt: new Date().toISOString(),
        reportId,
      };
      await store.put(record);
      return record;
    },
    async list(agentId) {
      const rows = await store.all();
      return rows.filter((row) => row.agentId === agentId);
    },
    async tag(id, reportId) {
      const rows = await store.all();
      const found = rows.find((row) => row.id === id);
      if (!found) return null;
      const next = { ...found, reportId };
      await store.put(next);
      return next;
    },
    async remove(id) {
      await store.delete(id);
    },
    async clearAgent(agentId) {
      const rows = await store.all();
      for (const row of rows) {
        if (row.agentId === agentId) await store.delete(row.id);
      }
    },
    async clearAll() {
      await store.clear();
    },
  };
}

export function memoryPhotoStore() {
  const rows = new Map();
  return {
    async put(record) { rows.set(record.id, record); },
    async all() { return [...rows.values()]; },
    async delete(id) { rows.delete(id); },
    async clear() { rows.clear(); },
  };
}
